export default __webpack_public_path__ + "static/logos-tiles-vi-67110da85c92edeaef4018d157ae1db6.svg";